import { render } from "./LeFootah.vue?vue&type=template&id=4d421846"
import script from "./LeFootah.vue?vue&type=script&lang=js"
export * from "./LeFootah.vue?vue&type=script&lang=js"

import "./LeFootah.vue?vue&type=style&index=0&id=4d421846&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__